import { RewardType } from 'root/src/shared/rewards/constants';
export function isInitialKey(product) {
    return product.type === RewardType.KEY;
}
export function isInitialCode(product) {
    return product.type === RewardType.CODE;
}
export function isInitialBundle(product) {
    return product.type === RewardType.BUNDLE;
}
export function isInitialCustom(product) {
    return product.type === RewardType.CUSTOM;
}
